export function moveModulesSearchBar() {
  let searchBar = document.querySelector('#catalog-left-nav .search-container');

  if (searchBar) {
    let catalogContent = document.querySelector('#catalog-content');
    catalogContent.prepend(searchBar);
  }
}